<template>
  <div>
    <el-button
      id="cba"
      type="primary"
      @click="addMaterialDialog = true"
      v-auth="'teachingResearch_/chapterMaterials/addDefaultChapterMaterials'"
      >添加学习资料</el-button
    >
    <el-table
      :data="attachments.attachments"
      border
      style="width: 100%; margin-top: 20px"
      v-auth="'teachingResearch_/chapterMaterials/getDefaultChapterMaterials'"
    >
      <el-table-column prop="name" label="附件">
        <template slot-scope="scope">
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-if="scope.row.editBlock"
              size="small"
              v-model="scope.row.name"
              style="width: 500px"
            >
              <span
                class="operation-style"
                style="line-height: 35px"
                slot="suffix"
                @click="updateDefaultChapterMaterials()"
                >保存</span
              >
              <span
                style="line-height: 35px; margin-left: 10px"
                slot="suffix"
                @click="editBlockCancel(scope.row)"
                >取消</span
              >
            </el-input>
            <div v-else>{{ scope.row.name }}</div>
            <i
              v-auth="'teachingResearch_/chapterMaterials/updateDefaultChapterMaterials'"
              style="line-height: 22.4px"
              class="operation-style el-icon-edit"
              @click="editBlockClick(scope.row)"
            ></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <div class="operationGroup">
            <i
              class="research-icon el-icon-download icon-style"
              @click="down(scope.row.url)"
              v-auth="'teachingResearch_down'"
            ></i>
            <i
              class="research-icon el-icon-delete icon-style"
              @click="delect(scope.row)"
              v-auth="'teachingResearch_/chapterMaterials/deleteDefaultChapterMaterials'"
            ></i>
            <span
              class="operation-style"
              @click="bingKnowledgePoints(scope.row.id)"
              v-auth="'teachingResearch_knowledgePointsSubmit'"
              >知识点</span
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="添加讲义"
      :visible.sync="addMaterialDialog"
      :close-on-click-modal="false"
      width="60%"
    >
      <addMaterial
        v-if="addMaterialDialog"
        @materialChange="materialChange"
      ></addMaterial>
    </el-dialog>

    <el-dialog
      title="绑定知识点"
      :visible.sync="knowledgePointsDialogVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <knowledgePoints
        v-if="knowledgePointsDialogVisible"
        :chapterForm="chapterData"
        @knowledgePointsClose="knowledgePointsClose"
        @knowledgePointsSubmit="knowledgePointsSubmit"
      ></knowledgePoints>
    </el-dialog>
  </div>
</template>

<script>
import addMaterial from "../../common/material";
import knowledgePoints from "./knowledgePoints";

export default {
  components: { addMaterial, knowledgePoints },
  props: {
    chapterForm: {
      id: 0,
    },
  },
  data() {
    return {
      knowledgePointsDialogVisible: false,
      addMaterialDialog: false,
      attachments: {},
      attachmentId: null,
    };
  },
  methods: {
    /*-----------------------------------------讲义列表操作------------------------------------ */
    getDefaultChapterMaterials() {
      this.attachments.attachments = [];
      this.api.chapterMaterials
        .getDefaultChapterMaterials({ chapterId: this.chapterForm.id })
        .then((result) => {
          if (result.success) {
            if (result.data.attachments != null) {
              result.data.attachments.forEach((e) => {
                this.$set(e, "editBlock", false);
              });
              this.attachments = result.data;
            }
          } else {
            this.$message.error(result.message);
          }
        });
    },

    editBlockClick(row) {
      this.$set(row, "editBlock", true);
    },
    editBlockCancel(row) {
      this.$set(row, "editBlock", false);
    },

    down(url) {
      window.open(url);
    },

    delect(row) {
      let _this = this;
      this.$confirm("确定删除该学习资料？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          let obj = {
            id: _this.attachments.id,
            attachments: [{ id: row.id }],
          };
          _this.api.chapterMaterials.deleteDefaultChapterMaterials(obj).then((result) => {
            if (result.success) {
              _this.getDefaultChapterMaterials();
            } else {
              _this.$message.error(result.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    /*-----------------------------------------添加讲义------------------------------------ */
    materialChange(ids) {
      let obj = {
        chapterId: this.chapterForm.id,
        type: 1,
        attachments: this.attachments.attachments,
      };
      if (this.attachments.attachments.length > 0) {
        obj.id = this.attachments.id;
        ids.forEach((item) => {
          let d = true;
          this.attachments.attachments.forEach((e) => {
            if (item.id == e.id) {
              d = false;
            }
          });
          if (d) {
            obj.attachments.push(item);
          }
        });
        this.api.chapterMaterials.updateDefaultChapterMaterials(obj).then((result) => {
          if (result.success) {
            this.getDefaultChapterMaterials();
            this.addMaterialDialog = false;
          } else {
            this.$message.error(result.message);
          }
        });
      } else {
        obj.attachments = ids;
        this.api.chapterMaterials.addDefaultChapterMaterials(obj).then((result) => {
          if (result.success) {
            this.getDefaultChapterMaterials();
            this.addMaterialDialog = false;
          } else {
            this.$message.error(result.message);
          }
        });
      }
    },
    updateDefaultChapterMaterials() {
      let obj = {
        chapterId: this.chapterForm.id,
        type: 1,
        attachments: this.attachments.attachments,
        id: this.attachments.id,
      };
      this.api.chapterMaterials.updateDefaultChapterMaterials(obj).then((result) => {
        if (result.success) {
          this.getDefaultChapterMaterials();
        } else {
          this.$message.error(result.message);
        }
      });
    },

    /*--------------------------------------绑定知识点------------------------------------ */
    bingKnowledgePoints(id) {
      this.attachmentId = id;
      this.chapterData = this.chapterForm;
      this.$set(this.chapterData, "attachmentId", id);
      this.$set(this.chapterData, "materialsId", this.attachments.id);
      this.knowledgePointsDialogVisible = true;
    },

    knowledgePointsClose() {
      this.knowledgePointsDialogVisible = false;
    },

    knowledgePointsSubmit(knowledgePointsForm, editBlock) {
      if (knowledgePointsForm.chapterKnowledgeList.length == 0) {
        this.$message.error("请选择知识点！");
      } else {
        let apiWay = "batchAddKnowledgeForChapterMaterials";
        if (editBlock) {
          apiWay = "batchUpdateKnowledgeForChapterMaterials";
        }
        let obj = {
          materialsId: this.attachments.id,
          attachmentId: this.attachmentId,
          chapterKnowledgeList: [],
        };
        knowledgePointsForm.chapterKnowledgeList.forEach((e) => {
          obj.chapterKnowledgeList.push({ id: e });
        });
        this.api.chapterMaterialsKnowledge[apiWay](obj).then((result) => {
          if (result.success) {
            this.knowledgePointsDialogVisible = false;
          } else {
            this.$message.error(result.message);
          }
        });
      }
    },
  },
  mounted() {
    if (this.chapterForm.id !== 0) {
      this.getDefaultChapterMaterials();
    }
  },
  watch: {
    "chapterForm.id"(val, oldVal) {
      if (val) {
        this.getDefaultChapterMaterials();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/teachingResearch/components/material.vue